import FileUploadModel from '../fileupload/FileUploadModel';
import fileUploadConfig from '../fileupload/fileUploadConfig';
import tmplFileDownloadInternalStatic from '../fileupload/FileDownloadInternalStaticTmpl.hbs'

export default async function downloadDocumentInternal(data) {
  const { fileId, fileName, isStatic } = data;
  const { timeout, searchPath } = fileUploadConfig;
  const downloadXml = isStatic ? tmplFileDownloadInternalStatic : fileUploadConfig.downloadInternalXml;

  const fileUploadModel = new FileUploadModel({
    tmplSoapMessage: downloadXml,
    timeout,
    searchPath,
    fileName,
    fileId
  });

  fileUploadModel.download($('#downloadFormUtil'));
}
